var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "0 0 67 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15541 1.02783C0.288669 1.90191 -0.000244141 3.35871 -0.000244141 5.10687V69.4974C-0.000244141 71.2456 0.577584 72.7024 1.44433 73.5765L1.73324 73.8678L37.5586 37.7392V37.1565L1.15541 1.02783Z",
    fill: "url(#paint0_linear_45_48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.115 49.977L37.2695 38.0313V37.1572L49.115 25.2114L49.4039 25.5028L63.5607 33.6609C67.6055 35.9917 67.6055 39.7794 63.5607 42.1103L49.115 49.977Z",
    fill: "url(#paint1_linear_45_48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4042 49.6854L37.2698 37.4482L1.15552 73.8682C2.60009 75.325 4.62249 75.325 7.22271 74.1596L49.4042 49.6854Z",
    fill: "url(#paint2_linear_45_48)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4042 25.21L7.22271 1.02711C4.62249 -0.42969 2.60009 -0.13833 1.15552 1.31847L37.2698 37.4471L49.4042 25.21Z",
    fill: "url(#paint3_linear_45_48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.1152 49.394L7.22271 73.2856C4.9114 74.7424 2.889 74.451 1.44443 73.2856L1.15552 73.5769L1.44443 73.8683C2.889 75.0337 4.9114 75.3251 7.22271 73.8683L49.1152 49.394Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.15566 73.2855C0.288913 72.4114 0 70.9546 0 69.2065V69.4978C0 71.246 0.577828 72.7028 1.44457 73.5769V73.2855H1.15566ZM63.5611 41.2359L49.1154 49.394L49.4043 49.6854L63.5611 41.5273C65.5835 40.3618 66.4502 38.905 66.4502 37.4482C66.4502 38.905 65.2946 40.0705 63.5611 41.2359Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.22285 1.31931L63.5611 33.6603C65.2946 34.8257 66.4502 35.9911 66.4502 37.4479C66.4502 35.9911 65.5835 34.5343 63.5611 33.3689L7.22285 1.02795C3.17805 -1.30293 0 0.445224 0 5.10698V5.39834C0 1.02795 3.17805 -1.01157 7.22285 1.31931Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_48",
    x1: 34.0916,
    y1: 4.55329,
    x2: -14.8056,
    y2: 53.0371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_48",
    x1: 68.8594,
    y1: 37.4515,
    x2: -1.04913,
    y2: 37.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_48",
    x1: 42.8371,
    y1: 44.1379,
    x2: -23.4682,
    y2: 109.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_48",
    x1: -7.80949,
    y1: -20.3121,
    x2: 21.8004,
    y2: 9.0492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.69f18a8e5cf87e5e5a66ca39301114ad.svg";
export { ForwardRef as ReactComponent };